var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1735_737)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1735_737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.94919 11.041C8.41073 11.041 10.4062 9.04549 10.4062 6.58396C10.4062 4.12242 8.41073 2.12695 5.94919 2.12695C3.48766 2.12695 1.49219 4.12242 1.49219 6.58396C1.49219 9.04549 3.48766 11.041 5.94919 11.041Z",
    stroke: "url(#paint0_linear_1735_737)",
    strokeWidth: 0.869116,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.28632 8.36716L6.2104 7.29124C6.04322 7.12411 5.94927 6.89741 5.94922 6.66102V3.91016",
    stroke: "#5F1314",
    strokeWidth: 0.869116,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1735_737",
    x1: 10.4062,
    y1: 6.58396,
    x2: 1.49219,
    y2: 6.58396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37384B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37384B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1735_737"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.5196,
    height: 11.5196,
    fill: "white",
    transform: "translate(0.1875 0.824219)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1735_737"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.6968,
    height: 10.6968,
    fill: "white",
    transform: "translate(0.601562 1.23633)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock);
export default __webpack_public_path__ + "static/media/icon-clock.58c802acfc1223a745370f84888a375d.svg";
export { ForwardRef as ReactComponent };